module.exports = __webpack_public_path__ + "img/3c-complete-vehicle.2b4c9c1e.png";